<template>
  <div id="R0" class="sub">
    <div class="wrapper">
      <kg-header :headerType=0 />
      <kg-userform />
    </div>
  </div>
</template>

<script>
// kagull Module
import Header from '../components/common/HomeIconHeader'
import UserForm from '../components/user/RegistUserForm'

export default {
  components: {
    'kg-header': Header,
    'kg-userform': UserForm
  },
  methods: {
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/RegistUserInput.vue